<template>
    <div :class="tigerLottery ? 'tiger-btn-area': 'other-btn'">
        <div class="myAwardBtn"
            :style="getButtonBgStyle">
            我的奖品
            <!-- 体验店小程序内场景，包括微信和支付宝小程序 -->
            <div v-if="miniprogramFlag || loginType == 'Alipay'"
                @click="goHiHonorMiniProgram('rewardQuery')"></div>
            <!-- 不在小程序内场景 -->
            <div v-if="!miniprogramFlag && loginType == 'wechat'"
                class="wxOpenLaunchWeapp">
                <!-- 体验店 -->
                <wx-open-launch-weapp id="launch-btn"
                    :env-version="env"
                    :username="hiHonorWxAppId"
                    path="subpackages/my/pages/rewardQuery/reward-query">
                    <script type="text/wxtag-template">
                        <div style="width: 100px; height: 500px; display: block; opacity: 0;" class="btn">打开小程序</div>
                    </script>
                </wx-open-launch-weapp>
            </div>
        </div>
        <div v-if="activityObj.prizeWinningScrollFlag != 0"
            class="winnerBtn"
            :style="getButtonBgStyle"
            @click="goWinnerList">
            中奖名单 &gt;
        </div>
    </div>
</template>
<script>
import wx from 'weixin-js-sdk';
import { config as configEnv } from '../../../../../commons/config.js';
import { config } from '@/api/config.js';
export default {
  props: {
    tigerLottery: false,
    miniprogramFlag: '',
    loginType: '',
    activityObj: Object,
  },
  computed: {
    getButtonBgStyle() {
      return {
        'border-color': this.activityObj.extendConfig.awardListButtonColor || '#ffffff',
        color: this.activityObj.extendConfig.awardListButtonColor || '#ffffff',
      };
    },
  },
  data() {
    return {
      env: configEnv.env === 'pro' ? 'release' : 'trial',
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  mounted() {},
  methods: {
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    goHiHonorMiniProgram(e) {
      this.$emit('goHiHonorMiniProgram', e);
    },
  },
};
</script>
<style lang="scss" scoped>
.tiger-btn-area {
  // margin-top: 20px;
  display: flex;
  padding: 20px;
  justify-content: space-between;
}
.other-btn {
  display: flex;
  padding: 20px;
  justify-content: space-between;
}
.winnerBtn,
.myAwardBtn {
  width: 85px;
  height: 24px;
  border: 1px solid #ffffff;
  border-radius: 12px;
  font-size: 13px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.myAwardBtn {
  div:nth-child(1),
  div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
  }
}
.wxOpenLaunchWeapp {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/reward-query.vue